require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-mittagessen-mittagessen-3-6-2017-18.json") })
        }
      }, "path---kriterien-mittagessen-mittagessen-3-6-2017-18");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-mittagessen-mittagessen-3-6-2017-18!./.cache/json/kriterien-mittagessen-mittagessen-3-6-2017-18.json
// module id = 1067
// module chunks = 231608221292675